import React from "react";


const SplitNumber = ({ number }) => {
  if (number == "" || number == undefined) return 0;

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default SplitNumber;
